var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-section",
    {
      staticClass: "frequency-modal__header",
      attrs: { bold: "", border: "none", size: 4, title: _vm.modalTitle },
      scopedSlots: _vm._u([
        {
          key: "mds-section-title-description",
          fn: function () {
            return [
              _c("mds-button", {
                attrs: {
                  variation: "icon-only",
                  icon: "question-circle",
                  type: "button",
                  target: "_blank",
                  href: _vm.supportUrl,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("p", { staticClass: "frequency-modal__description" }, [
        _vm._v("\n    " + _vm._s(_vm.translate(_vm.modalDescription)) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }